/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime (time, cFormat) {
    if (arguments.length === 0 || !time) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if ((typeof time === 'string')) {
            if ((/^[0-9]+$/.test(time))) {
                // support "1548221490638"
                time = parseInt(time)
            } else {
                // support safari
                // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
                time = time.replace(new RegExp(/-/gm), '/')
            }
        }

        if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') {
            return ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'][value]
        }
        return value.toString().padStart(2, '0')
    })
    return time_str
}
/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime (time, option) {
    if (('' + time).length === 10) {
        time = parseInt(time) * 1000
    } else {
        time = +time
    }
    const d = new Date(time)
    const now = Date.now()

    const diff = (now - d) / 1000

    if (diff < 30) {
        return '刚刚'
    } else if (diff < 3600) {
        // less 1 hour
        return Math.ceil(diff / 60) + '分钟前'
    } else if (diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + '小时前'
    } else if (diff < 3600 * 24 * 2) {
        return '1天前'
    }
    if (option) {
        return parseTime(time, option)
    } else {
        return (
            d.getMonth() +
            1 +
            '月' +
            d.getDate() +
            '日' +
            d.getHours() +
            '时' +
            d.getMinutes() +
            '分'
        )
    }
}

// 如果time2大于time1 返回true 否则 返回false
export function compareTime (time1, time2) {
    if (time_to_sec(time2) - time_to_sec(time1) > 0) {
        return true;
    }
    return false;
}

//将时分秒转为时间戳
function time_to_sec (time) {
    if (time !== null) {
        var s = "";
        var hour = time.split(":")[0];
        var min = time.split(":")[1];
        var sec = time.split(":")[2];
        s = Number(hour * 3600) + Number(min * 60) + Number(sec);
        return s;
    }
}


// 获取url 参数code
export function getUrlParamsCode (url, code) {
    if (encodeURI(url).includes('?')) {
        const arr = encodeURI(url).split('?')[1]
        const newArr = arr.includes('&') ? arr.split('&') : [arr]
        const obj = {}
        newArr.forEach(item => {
            const paramsArr = item.split('=')
            obj[paramsArr[0]] = paramsArr[1]
        })
        if (code === 'code') {
            if (obj.code) {
                return obj.code
            }
        } else {
            return obj
        }

    } else {
        return ''
    }
}
// 获取上一个月
export function getBeforeMonth (date) {
    let now = new Date(date);
    // 当前年月的日
    let nowDate = now.getDate();
    //当前月份完整日期 (Thu Jul 07 2022 12:03:37 GMT+0800 (中国标准时间))
    let beforeMonthStart = new Date(now.getTime());
    // 设置上一个月（这里不需要减1） getMonth()返回表示月份的数字 setMonth()设置月份参数
    beforeMonthStart.setMonth(beforeMonthStart.getMonth());
    // 设置为0，默认为当前月的最后一天
    beforeMonthStart.setDate(0);
    // 上一个月的天数
    let daysOfBeforeMonthStarth = beforeMonthStart.getDate();
    // 设置上一个月的日期，如果当前月的日期大于上个月的总天数，则为最后一天
    // 例如当前是3月31，而2月只有28或29天，则取2月的最后一天
    beforeMonthStart.setDate(nowDate > daysOfBeforeMonthStarth ? daysOfBeforeMonthStarth : nowDate);
    //调用格式化日期函数
    beforeMonthStart = parseTime(beforeMonthStart, '{y}-{m}-{d}');

    return {
        'start': beforeMonthStart,
        'end': getLastDay(beforeMonthStart)
    }
}
// 获取下一个月
export function getNextMonth (date) {
    let now = new Date(date), //获取当前时间
        year = now.getFullYear(), //获取当前时间的年份
        month = now.getMonth(), //获取当前时间的月份
        day = now.getDate(), //获取当前时间的日
        newYear = year,
        nextMonth = parseInt(month + 2), //获取当前月份的一个月以后的月份
        currentDay = day;
    /* 				days = new Date(year, month, 0) //将获取到的年月赋值给days
              days = days.getDate() //获取当前年月的日 */
    //考虑到12月要是获取一个月以后，就是一月，年份需要加一 ，一年没有13月，所以%12，取得来年1月
    if (nextMonth > 12) {
        newYear = parseInt(newYear) + 1;
        nextMonth = parseInt(nextMonth) % 12;
    }
    let nextDay = new Date(newYear, nextMonth, 0); //将获取到的年月赋值给nextDay
    nextDay = nextDay.getDate(); //获取当前月份的一个月以后的日

    /* 			获取了当前年份的日和1个月以后的日，为的就是判断如果前一个月是有31号，
              后一个月没有，就将一个月以后的日期取到，赋值给currentDay */
    currentDay = currentDay > nextDay ? nextDay : currentDay;
    nextMonth = nextMonth < 10 ? "0" + nextMonth : nextMonth;
    currentDay = currentDay < 10 ? "0" + currentDay : currentDay;
    const newDay = `${newYear}-${nextMonth}-${currentDay}`

    return {
        'start': newDay,
        'end': getLastDay(newDay)
    }
}
// 获取当前时间月的最后一天
function getLastDay (date) {
    var year = new Date(date).getFullYear(); //获取年份
    var month = new Date(date).getMonth() + 1; //获取月份
    var lastDate = new Date(year, month, 0).getDate(); //获取当月最后一日
    month = month < 10 ? '0' + month : month; //月份补 0
    return [year, month, lastDate].join("-")
}

export function getLastMonthDay (date) {
    var year = new Date(date).getFullYear(); //获取年份
    var month = new Date(date).getMonth() + 1; //获取月份
    var lastDate = new Date(year, month, 0).getDate(); //获取当月最后一日
    month = month < 10 ? '0' + month : month; //月份补 0
    return [year, month, lastDate].join("-")
}